import { DOMAIN_TITLE } from '@/config/env';
import store from '@/store';

export const routes = [
    {
        path: '/login',
        name: 'Login',
        component: resolve => require(['@/pages/Login.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE} | Login`, auth:false, front: false }
    },
    {
        path: '/admin/',
        component: resolve => require(['@/pages/admin/Index.vue'], resolve),
        meta: { auth:true, front: false },
        children: [
            ,
            {
                path: '/',
                redirect:'dashboard',
            }, 
            {
                path: 'dashboard',
                name: 'dashboard',
                component: resolve => require(['@/pages/admin/Dashboard.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Dashboard`,  auth:true, front: false }
            },
            {
                path: 'users',
                name: 'users',
                component: resolve => require(['@/pages/admin/Users.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Utilisateurs`,  auth:true, front: false }
            },
            {
                path: 'dyn-contents',
                name: 'dynContents',
                component: resolve => require(['@/pages/admin/DynamicContents.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Contenus dynamiques`,  auth:true, front: false }
            },
            {
                path: 'item/:newsType',
                name: 'news',
                component: resolve => require(['@/pages/admin/News.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Contenu`,  auth:true, front: false }
            },
            {
                path: 'project',
                name: 'project',
                component: resolve => require(['@/pages/admin/Projects.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Contenu`,  auth:true, front: false }
            },
            {
                path: 'upload',
                name: 'upload',
                component: resolve => require(['@/components/upload-images.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Journal`,  auth:true, front: false }
            }
        ]
    },    
    {
        path: '/:lng',
        component: resolve => require(['@/pages/Index.vue'], resolve),
        meta: { auth:false, front: true  },
        children: [     
             {
                path: '/',
                name: 'home',
                component: resolve => require(['@/pages/front/Home.vue'], resolve),
                meta: { auth:false, front: true, menu: false }
            },           
            {
                path: 'studio',
                name: 'studio',
                component: resolve => require(['@/pages/front/Studio.vue'], resolve),
                meta: { auth:false, front: true, menu: false }
            },
            {
                path: 'newsroom',
                name: 'newsroom',
                component: resolve => require(['@/pages/front/Newsroom.vue'], resolve),
                meta: { auth:false, front: true, menu: false }
            },
            {
                path: 'projects',
                name: 'projects',
                component: resolve => require(['@/pages/front/Projects.vue'], resolve),
                meta: { auth:false, front: true, menu: false }
            },            
            {
                path: 'contact',
                name: 'contact',
                component: resolve => require(['@/pages/front/Contact.vue'], resolve),
                meta: { auth:false, front: true, menu: false }
            },             
            {
                path: 'project-details/:projectSlug',
                name: 'project-details',
                component: resolve => require(['@/pages/front/Project-details.vue'], resolve),
                //props: true,
                meta: { auth:false, front: true, menu: false }
            },
            {
                path: 'blog',
                name: 'blog',
                component: resolve => require(['@/pages/front/Blog.vue'], resolve),
                meta: { auth:false, front: true, menu: false }
            },
        ]
    },

    
    {
        path: '*',
        beforeEnter(to, from, next){
            //console.log("erreur 404", store);
            //console.log(to);
            
            if (to.path == "/")
            {
                //this.push({ path: '/fr' });
                next({
                    path: '/' + store.getters.currentLng,
                })                
            }
            else
                next();
            
        },        
        component: resolve => require(['@/pages/404.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE} | Erreur 404` }
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js